import { Controller } from "@hotwired/stimulus";

const STORAGE_KEY = "elron_cookie_consent_v1";
const STORAGE_VERSION = "v1";
const HIDDEN_CLASS = "hidden";

type CookieConsent = {
    version: string;
    essential: true;
    analytics: boolean;
    support: boolean;
    acceptedAt: string;
};

function readStoredConsent(): CookieConsent | null {
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw) as CookieConsent;
        if (parsed.version !== STORAGE_VERSION) return null;
        return parsed;
    } catch {
        return null;
    }
}

function writeConsent(consent: CookieConsent): void {
    try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(consent));
        window.dispatchEvent(new CustomEvent("elron:cookie-consent", { detail: consent }));
    } catch {
        // Storage may be unavailable (private mode); the banner will simply re-appear next time.
    }
}

export default class extends Controller<HTMLElement> {
    connect(): void {
        const existing = readStoredConsent();
        if (!existing) {
            this.element.classList.remove(HIDDEN_CLASS);
        }
    }

    accept(): void {
        writeConsent({
            version: STORAGE_VERSION,
            essential: true,
            analytics: true,
            support: true,
            acceptedAt: new Date().toISOString(),
        });
        this.element.classList.add(HIDDEN_CLASS);
    }

    reject(): void {
        writeConsent({
            version: STORAGE_VERSION,
            essential: true,
            analytics: false,
            support: false,
            acceptedAt: new Date().toISOString(),
        });
        this.element.classList.add(HIDDEN_CLASS);
    }
}
